import { ApplicationState } from '../store/models'

export const isConsultantOpenSelector = (state: ApplicationState) => state.consultant?.isOpen
